<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-12">
                  <span class="titulo bold">Generar reporte</span>
                </div>
              </div>

              <div class="contenido">
                <form
                  class="row mx-3"
                  method="post"
                  @submit="submitFormulario($event)"
                >
                  <div
                    class="formulario col-12 bg-white shadow p-4 rounded card"
                  >
                    <div class="row">
                      <div class="col-12">
                        <i class="fas fa-calendar-alt fM2"></i>
                        <span class="fR bold"> Selecciona el periodo: </span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Fecha de Inicio:</span>
                            <input
                              type="date"
                              v-model="form.fecha_ini"
                              maxlength="100"
                              placeholder="Fecha de Inicio"
                            />
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Fecha de Término:</span>
                            <input
                              type="date"
                              v-model="form.fecha_fin"
                              maxlength="100"
                              placeholder="Fecha de Inicio"
                            />
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 text-center">
                        <button type="submit" class="submit btnnaranja">
                          Generar Reporte
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="contenido py-5" v-if="data != null">
                  <div class="col-12 card shadow round py-5">
                    <div class="row">
                      <div class="col-12 pb-4">
                        <download-excel class="float-right" :data="data" name="Gaig - reporte.xls">
                           <button class="btn btngris fM2"><i class="fas fa-download"></i> Exportar </button>
                        </download-excel>
                      </div>
                    </div>

                    <v-client-table
                      :columns="columns"
                      v-model="data"
                      :options="options"
                    >
                      <router-link
                        slot="uri"
                        slot-scope="props"
                        :to="'/registro/' + props.row.id"
                        class="text-center negro"
                      >
                        <i class="fas fa-eye"></i> Ver
                      </router-link>

                      <div
                        slot="name"
                        slot-scope="{
                          row,
                          update,
                          setEditing,
                          isEditing,
                          revertValue,
                        }"
                      >
                        <span @click="setEditing(true)" v-if="!isEditing()">
                          <a>{{ row.name }}</a>
                        </span>
                        <span v-else>
                          <input type="text" v-model="row.name" />
                          <button
                            type="button"
                            class="btn btn-info btn-xs"
                            @click="
                              update(row.name);
                              setEditing(false);
                            "
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            class="btn btn-default btn-xs"
                            @click="
                              revertValue();
                              setEditing(false);
                            "
                          >
                            Cancel
                          </button>
                        </span>
                      </div>
                    </v-client-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      paso: 1,
      form: {
        fecha_ini: "",
        fecha_fin: "",
      },
      tiposervicio: "",
      columns: [
        "retailer_razon_social",
        "no_certificado",
        "no_poliza",
        "razon_social",
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        "rfc",
        "email",
        "vigencia_ini",
        "vigencia_fin",
        "marca",
        "ano",
        "modelo",
        "no_serie",
        "valor_factura",
        "prima_neta",
        "iva",
        "timestamp",
        
        //"uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          retailer_razon_social: "Razón Social Retailer",
          ano: "Año",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          vigencia_ini: "Vigencia Inicio",
          vigencia_fin: "Vigencia Fin",
          iva: "IVA",
          no_serie: "No. de serie",
          rfc: "RFC",
          timestamp: "Fecha Registro",
          
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    AOS.init();

    //this.consulta();
  },
  methods: {
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.rfc = "";
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      this.paso++;

      if (this.paso == 5) {
        //calcular prima, iva, etc
        let valor_factura = this.form.valor_factura;
        let prima_neta = 0;
        if (valor_factura > 0) {
          //calcular prima neta
          if (valor_factura <= 50000) {
            this.form.prima_neta = 862.06;
          } else if (valor_factura <= 100000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.052).toFixed(2);
          } else if (valor_factura <= 300000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          } else {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          }

          //calcular derechos de poliza
          if (this.form.prima_neta <= 1000) {
            this.form.derecho_de_poliza = 125.0;
          } else if (this.form.prima_neta <= 5000) {
            this.form.derecho_de_poliza = 250.0;
          } else if (this.form.prima_neta <= 10000) {
            this.form.derecho_de_poliza = 325.0;
          } else if (this.form.prima_neta <= 30000) {
            this.form.derecho_de_poliza = 500.0;
          } else {
            this.form.derecho_de_poliza = 700.0;
          }

          //calcular iva
          this.form.iva = parseFloat(
            (parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza)) *
              0.16
          ).toFixed(2);
          this.form.prima_total = parseFloat(
            parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza) +
              parseFloat(this.form.iva)
          ).toFixed(2);
        }
      }
    },
    regresar() {
      this.paso--;
    },
    submitFormulario(e) {
      //terminar
      e.preventDefault();

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        admin_id: this.$store.state.user.admin_id,
        user_id: this.$store.state.user.id,
        fecha_ini: this.form.fecha_ini,
        fecha_fin: this.form.fecha_fin
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "consulta-generar-reporte.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    changeVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date(this.form.vigencia_ini);
      date.setFullYear(date.getFullYear() + 1);
      this.form.vigencia_fin =
        this.formatDate(date) + "T" + this.formatTime(date);

      //console.log(this.form.vigencia_fin);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;

      return [hour, minute].join(":");
    },
  },
};
</script>

